import React from 'react';
import './tutorLiveClasses.scss';
import clockIcon from "../../../../assets/icons/clock.svg"
import EmptyState from "../../../../shared/components/EmptyState";

const TutorLiveClasses = () => {
    return (
        <div className='tutor__live-class'>
            <div className='live-class__header'>
                <img src={clockIcon} alt=''/> Upcoming Live Classes
            </div>
            <EmptyState text={'No live classes found.'}/>
        </div>
    )
}

export default TutorLiveClasses;
